import { css } from '@emotion/react'
import { Modal, ModalBody, ModalHeader } from 'bold-ui'
import { TipoRegulacaoEnum } from 'graphql/types.generated'
import { humanizeAge } from 'util/date/humanize-age'

import { ListaRegulacaoTableItem } from '../model-regulacao'
import { HistoricoRegulacaoEvolucao } from './components/HistoricoRegulacaoEvolucao'
import { RegulacaoModalItem } from './components/RegulacaoModalItem'

interface ListaRegulacaoModalProps {
  item: ListaRegulacaoTableItem
  handleClose(): void
}

export const ListaRegulacaoModal = (props: ListaRegulacaoModalProps) => {
  const { item, handleClose } = props

  const cidadao = item.prontuario.cidadao
  const equipe = cidadao.cidadaoVinculacaoEquipe?.equipe?.nome ?? 'Sem equipe'
  const ubs = cidadao.cidadaoVinculacaoEquipe?.unidadeSaude?.nome
  const subtitle = [(cidadao.nomeSocial ?? cidadao.nome).titleCase(), humanizeAge(cidadao.dataNascimento), equipe, ubs]
    .filterNotNull()
    .join(' | ')

  return (
    <Modal open={true} onClose={handleClose} size='large' style={styles.modal}>
      <ModalHeader title={titleByTipoRegulacaoEnumMap[item.tipoRegulacao]} subtitle={subtitle} />
      <ModalBody style={{ padding: '1rem 2rem 2rem' }}>
        <HistoricoRegulacaoEvolucao id={item.id} />
        <RegulacaoModalItem item={item} />
      </ModalBody>
    </Modal>
  )
}

const titleByTipoRegulacaoEnumMap: Record<TipoRegulacaoEnum, string> = {
  GUIA_ENCAMINHAMENTO: 'Solicitação de guia de encaminhamento',
  SOLICITACAO_EXAME_COMUM: 'Solicitação de exame comum',
  SOLICITACAO_EXAME_ALTO_CUSTO: 'Solicitação de exame de alto custo',
  SOLICITACAO_EXAME_OCI: 'Solicitação de procedimento OCI',
}

const styles = {
  modal: css`
    width: 55rem;
  `,
}
